import { cn } from '@commenda/utils';
import React from 'react';
import { Badge as BadgePrimitive, BadgeProps } from '../Badge';
import { Button as ButtonPrimitive, ButtonProps } from '../Button';

const Root = ({
  children,
  _className = '',
  onClick,
}: {
  children: React.ReactNode;
  _className?: string;
  onClick?: () => void;
}) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-3xl rounded-xl p-4 bg-bg-primary border border-border-primary',
        _className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

const Header = ({
  children,
  _className,
}: {
  children: React.ReactNode;
  _className?: string;
}) => {
  return (
    <div className={cn('flex justify-between items-start gap-6', _className)}>
      {children}
    </div>
  );
};

const Title = ({
  children,
  _className,
}: {
  children: React.ReactNode;
  _className?: string;
}) => {
  return (
    <div className={cn('txt-medium-bold text-text-primary', _className)}>
      {children}
    </div>
  );
};

const Badge = ({
  variant = 'gray',
  children,
}: {
  variant?: BadgeProps['variant'];
  children: React.ReactNode;
}) => {
  return (
    <BadgePrimitive size="sm" variant={variant}>
      {children}
    </BadgePrimitive>
  );
};

const Description = ({
  children,
  _className,
}: {
  children: React.ReactNode;
  _className?: string;
}) => {
  return (
    <p className={cn('txt-small-regular text-text-tertiary', _className)}>
      {children}
    </p>
  );
};

const Footer = ({
  children,
  _className,
}: {
  children: React.ReactNode;
  _className?: string;
}) => {
  return (
    <div className={cn('flex items-center gap-xl', _className)}>{children}</div>
  );
};

const Button = ({
  variant = 'primary',
  children,
  ...restProps
}: {
  variant: ButtonProps['variant'];
  children: React.ReactNode;
} & ButtonProps) => {
  return (
    <ButtonPrimitive variant={variant} size="sm" {...restProps}>
      {children}
    </ButtonPrimitive>
  );
};

export const Card = {
  Root,
  Header,
  Title,
  Badge,
  Description,
  Footer,
  Button,
};
